export type ContentImageFields = {
  imageUrl?: string | null;
  thumbnailUrl?: string | null;
  headerImage?: string | null;
};

function nonEmpty(value?: string | null): string | null {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}

/**
 * List / ticker / popup image. Prefer the cropped thumbnail so a tall full card
 * is not squeezed into a square tile.
 */
export function resolveThumbnailUrl(item?: ContentImageFields | null): string | null {
  if (!item) return null;
  return (
    nonEmpty(item.thumbnailUrl) || nonEmpty(item.imageUrl) || nonEmpty(item.headerImage) || null
  );
}

/**
 * Full-article hero. Prefer the full card / header, then the thumbnail.
 */
export function resolveHeroImageUrl(item?: ContentImageFields | null): string | null {
  if (!item) return null;
  return (
    nonEmpty(item.imageUrl) || nonEmpty(item.headerImage) || nonEmpty(item.thumbnailUrl) || null
  );
}

/**
 * Resolve the blog/article image used on the home ticker, featured popup,
 * and content cards. Prefers thumbnail when a separate full-card hero exists.
 */
export function resolveContentImageUrl(item?: ContentImageFields | null): string | null {
  return resolveThumbnailUrl(item);
}

export function featuredArticlePath(id?: string | null): string {
  return id ? `/content?article=${encodeURIComponent(id)}` : '/content';
}

export function articleIdFromSearch(
  search: string = typeof window !== 'undefined' ? window.location.search : ''
): string | null {
  try {
    return new URLSearchParams(search).get('article');
  } catch {
    return null;
  }
}

export function stripHtml(text?: string | null): string {
  if (!text) return '';
  return text
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}
